import React from 'react';
import PropTypes from 'prop-types';
import DropzoneComponent from 'react-dropzone';

import { DEFAULT_FILES_WHITE_LIST, IMAGE_FILES_WHITE_LIST, MAXIMUM_FILE_SIZE_BYTES} from 'constants/forms';
import { errorNotification } from 'utils';

import Template from './Template';
import './style.css';

const propTypes = {
  filesWhitelist: PropTypes.string,
  multiple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  template: PropTypes.func,
  isImages: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.any)]),
};

const defaultProps = {
  filesWhitelist: DEFAULT_FILES_WHITE_LIST,
  multiple: false,
  template: undefined,
  title: undefined,
  isImages: false,
  value: [],
};

function Dropzone({ value, title, filesWhitelist, multiple, onChange, invalid, template, isImages, ...props }) {
  return (
    <DropzoneComponent
      accept={isImages ? IMAGE_FILES_WHITE_LIST : filesWhitelist}
      multiple={multiple}
      className="dropzone"
      disableClick
      maxSize={MAXIMUM_FILE_SIZE_BYTES}
      onDrop={onChange}
      onDropRejected={() => errorNotification('File is too large. Maximum file size is 100MB.')}
      {...props}
    >
      {template || (({ open }) => <Template value={value} title={title} open={open} />)}
    </DropzoneComponent>
  );
}

Dropzone.propTypes = propTypes;
Dropzone.defaultProps = defaultProps;

export default Dropzone;
